import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect } from "react";

export const useRateGroupURLParams = () => {
  const setDefaultRateGroups = useEngineStore((state) => state.setDefaultRateGroups);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const rateGroupCodesParam = urlParams.getAll(URLParam.RateGroup);

    setDefaultRateGroups(rateGroupCodesParam);
    // eslint-disable-next-line
  }, []);
};

export const useClearRateGroupURLParams = () => {
  const setDefaultRateGroups = useEngineStore((state) => state.setDefaultRateGroups);

  return async () => {
    setDefaultRateGroups([]);

    // Return a new Promise for the synchronous URL update operations
    return new Promise<void>((resolve) => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete(URLParam.RateGroup);
      window.history.replaceState(window.history.state, "", `?${urlParams.toString()}`);
      resolve(); // Resolve the promise after updating the URL parameters
    });
  };
};
